<template>
  <div class="container">
    <h2 class=" uk-text-center">{{assessment.title}}</h2>
    <p class="uk-text-center"><span v-if="message" class="uk-text-small uk-text-light" :class="message.type">{{message.text}}</span></p>
    <div v-for="(question, index) in assessment.questions" :key="question._id">
        <div class="uk-card uk-card-default uk-width-1-1@s" v-show="qsIdx === index">
          <div class="uk-card-header">
              <div class="uk-card-badge uk-label">Question {{qsIdx + 1}} of {{count}}</div>
              <h3 class="uk-card-title">{{question.title}}</h3>
          </div>
          <div class="uk-card-body  uk-margin">
            <div class="uk-inline uk-width-1-1">
            <div class="uk-position-center">
              <template v-for="answer in question.answers">
                  <label :key="answer._id" class="answer"><input class="uk-radio" type="radio" v-bind:value="answer" v-model="answers[index]"> {{answer.title}}</label><br />
              </template>
            </div>
            </div>
          </div>
          <div class="uk-card-footer uk-text-center">
              <button href="#" class="uk-button uk-button-default" v-if="qsIdx > 0" @click.prevent="prev()">
                <span uk-icon="chevron-left"></span> Prev
              </button>
              <button href="#" class="uk-button uk-button-default uk-margin-small-left" @click.prevent="next()" :disabled="typeof answers[index] !== 'object'">
                Next <span uk-icon="chevron-right"></span> 
              </button>
          </div>
        </div>
    </div>
    <div class="uk-card uk-card-default uk-card-body uk-width-1-1@s" v-show="qsIdx === count">
      <h3 class="uk-card-title uk-text-center" style="width: 100%">Successful completion of the assessment</h3>
      <p><button class="uk-button uk-button-default" @click.prevent="eventSaveResult()">See the result</button></p>
    </div>
  </div>
</template>

<script>
import AssessmentService from '@/services/assessment.service';
import CompletedService from '@/services/completed.service';
export default {
    name: 'StartAssessment',
    data() {
      return {
        assessment: {},
        message: '',
        qsIdx: 0,
        answers: [],
        count: 0
      }
    },
    created() {
      if(this.$route.params.id === undefined) {
        this.$router.push({name: "error404"});
      } else {
        this.getAssessment(this.$route.params.id);
      }
      setInterval(() => {
        this.message = null;
      }, 10000)
  },
  methods: {
    getAssessment(id) {
       AssessmentService.one(id).then(
            res => {
              this.assessment = res.data;
              if(this.assessment.questions === undefined){
                this.assessment.questions = [];
              } else {
                this.assessment.questions = res.data.questions.map(obj=> ({ ...obj, isEdit: false }));
                if (this.assessment.isSortingByLevel) {
                  this.assessment.questions =  this.assessment.questions.sort((a, b) => {
                      if (a.level < b.level) {
                          return -1;
                      }
                      if (a.level > b.level) {
                          return 1;
                      }
                      return 0;
                  });
                }
                if (this.assessment.isRandom) {
                  this.assessment.questions = this.assessment.questions.sort( () => Math.random() - 0.5);
                }
              }
              this.count = this.assessment.questions.length;
              this.message = {text: res.data.message, type: 'uk-text-success'}
            },
            error => {
              let message = (error.response && error.response.data.message.message) || error.message || error.toString();
              this.message = {text: message, type: 'uk-text-danger'}
            }
          ) 
    },
    eventSaveResult() {
      CompletedService.create({parentId: this.assessment._id, answers: this.answers, type: this.assessment.type}).then(
        res => {
          this.message = {text: res.data.message, type: 'uk-text-success'}
          this.$store.commit('auth/incrementAttempt');
          setTimeout(() =>  this.$router.push({ name: 'assessment.completed', params: { id: res.data.id } }), 3000);
        },
        error => {
          let message = (error.response && error.response.data.message.message) || error.message || error.toString();
          this.message = {text: message, type: 'uk-text-danger'}
        }
      )
    },
    next(){
      this.qsIdx++;
    },
    prev(){
      this.qsIdx--;
    },
  },
}
</script>

<style>
.uk-card {
  width: 70vw;
}
.uk-card-default .uk-card-footer {
    border-top: none;
}
.uk-card-default .uk-card-header .uk-label{
    text-transform: none;
}
.uk-card-default .uk-card-title{
  width: 80%;
}
.answer {
  position: relative;
  display: inline-block;
  margin: 5px 0;
  color: #606266;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  outline: 0;
  text-align: left;
}
</style>